import { Footer } from '@toctoc/design-system';
import { FooterCollectionType } from './interfaces';
import { FC } from 'react';

export const FooterIndex: FC<{ footerData: FooterCollectionType | undefined | null }> = ({ footerData }) => {
	if (footerData === undefined || footerData === null)
		return null;
	return (
		<Footer
			claseAux=""
			footerOptions={{...footerData, origenFooter: "footer"}}
			urlBase='https://www.toctoc.com/'
		/>
	)
}
